import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class ProductsSettingValidator {

    type = [
        Validators.required
    ];
    media_format = [
        Validators.required
    ];
    media_attributes = [
        Validators.required
    ];
    group_by = [
        Validators.required
    ];
    text_format = [
        Validators.required
    ];
    text_attributes = [
        Validators.required
    ];

    // Error messages
    errorMessages = {

        type: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        media_format: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        media_attributes: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        group_by: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        text_format: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        text_attributes: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}